import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { ITransportMostAffectedWorstODPairs } from "./models/widget-transport-most-affected-worst-od-pairs";
import { TransferWorstODPairsService } from "./services/widget-transfer-worst-od-pairs.service";
import { GenericUtils } from "./../../../utilities/generic-utils";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-widget-transportation-most-affected-worst-od-pairs",
  templateUrl: "./widget-transport-most-affected-worst-od-pairs.component.html",
  styleUrls: ["./widget-transport-most-affected-worst-od-pairs.component.scss"],
  providers: [TransferWorstODPairsService]
})
export class WidgetTransportationWorstODPairsComponent
  implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE: string;
  @Input() HEADINGS: string[];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object = {};
  data = null;
  errorMessage = "";
  mockData = null;

  constructor(
    private returnWorstPairService: TransferWorstODPairsService,
    private utils: GenericUtils
  ) { }

  ngOnInit() {
    this.getReturnWorstPairService();
  }
  toFixedRate(value) {
    return value.toFixed(2);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getReturnWorstPairService();
    }
  }

  getReturnWorstPairService() {
    this.data = null;
    this.mockData = null;
    this.errorMessage = "";
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.page_offset = "6";
    this.returnWorstPairService.getWorstODPairs(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data[0] && response.data[0].length && Object.keys(response.data[0]).length && response.data[0].TransportationMostAffectedODPairs.length) {
            this.data =
              response["data"][0].TransportationMostAffectedODPairs || null;
            this.data.map(worstPair => {
              worstPair.total_value = this.utils.amountIndianUnit(
                worstPair.total_value
              );
              return worstPair;
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.displayedColumns;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.displayedColumns;
        }
      );
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
